import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, MapPin, Phone } from 'lucide-react';
import { Button } from '../ui/Button';
export function Footer() {
  return <footer className="bg-gray-900 text-white pt-16 pb-8" data-id="element-168">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-170">
          {/* Brand Info */}
          <div data-id="element-171">
            <Link to="/" className="inline-block mb-6" data-id="element-172">
              <img src="https://cdn.magicpatterns.com/uploads/qQo6jWGHqPUtLJiByYjECh/Footer-logo.png" alt="Limitless Taekwondo" className="h-24 w-auto" data-id="element-173" />
            </Link>
            <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-174">
              Building confidence, discipline, and character through Taekwondo
              in Brighton, Michigan. Family-focused and community-driven.
            </p>
            <div className="flex space-x-4" data-id="element-175">
              <a href="https://www.facebook.com/Limitlessmartialart/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-accent transition-colors" aria-label="Facebook" data-id="element-176">
                <Facebook className="h-6 w-6" data-id="element-177" />
              </a>
              <a href="https://instagram.com/LimitlessMA" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-accent transition-colors" aria-label="Instagram" data-id="element-178">
                <Instagram className="h-6 w-6" data-id="element-179" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-180">
            <h4 className="text-lg font-semibold mb-6" data-id="element-181">Quick Links</h4>
            <ul className="space-y-2" data-id="element-182">
              <li data-id="element-183">
                <Link to="/" className="text-gray-400 hover:text-white transition-colors" data-id="element-184">
                  Home
                </Link>
              </li>
              <li data-id="element-185">
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors" data-id="element-186">
                  About
                </Link>
              </li>
              <li data-id="element-187">
                <Link to="/programs" className="text-gray-400 hover:text-white transition-colors" data-id="element-188">
                  Programs
                </Link>
              </li>
              <li data-id="element-189">
                <Link to="/schedule" className="text-gray-400 hover:text-white transition-colors" data-id="element-190">
                  Schedule
                </Link>
              </li>
              <li data-id="element-191">
                <Link to="/staff" className="text-gray-400 hover:text-white transition-colors" data-id="element-192">
                  Staff
                </Link>
              </li>
              <li data-id="element-193">
                <Link to="/gallery" className="text-gray-400 hover:text-white transition-colors" data-id="element-194">
                  Gallery
                </Link>
              </li>
              <li data-id="element-195">
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-196">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-197">
            <h4 className="text-lg font-semibold mb-6" data-id="element-198">Contact Us</h4>
            <ul className="space-y-4" data-id="element-199">
              <li className="flex items-start" data-id="element-200">
                <MapPin className="h-5 w-5 text-accent mr-3 mt-1 flex-shrink-0" data-id="element-201" />
                <span className="text-gray-400" data-id="element-202">
                  1363 S. Old US 23
                  <br data-id="element-203" />
                  Brighton, Michigan 48114
                </span>
              </li>
              <li className="flex items-center" data-id="element-204">
                <Phone className="h-5 w-5 text-accent mr-3 flex-shrink-0" data-id="element-205" />
                <a href="tel:8107753153" className="text-gray-400 hover:text-white transition-colors" data-id="element-206">
                  (810) 775-3153
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div data-id="element-207">
            <h4 className="text-lg font-semibold mb-6" data-id="element-208">Class Hours</h4>
            <ul className="space-y-2 text-gray-400 mb-6" data-id="element-209">
              <li className="flex justify-between" data-id="element-210">
                <span data-id="element-211">Mon - Thu</span>
                <span data-id="element-212">4:00 PM - 8:30 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-213">
                <span data-id="element-214">Friday</span>
                <span data-id="element-215">4:00 PM - 7:30 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-216">
                <span data-id="element-217">Saturday</span>
                <span data-id="element-218">9:00 AM - 12:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-219">
                <span data-id="element-220">Sunday</span>
                <span data-id="element-221">Closed</span>
              </li>
            </ul>

            {/* CTA Button */}
            <Link to="/trial" className="block" data-id="element-222">
              <Button variant="primary" className="w-full bg-accent hover:bg-accent-dark text-white border-none" data-id="element-223">
                Start 4-Week Trial
              </Button>
            </Link>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-500 text-sm" data-id="element-224">
          <p data-id="element-225">
            &copy; {new Date().getFullYear()} Limitless Taekwondo. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}